module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/paypal-b89ab02516aecfd401080fa58829ef58.png";